import moment from 'moment-timezone';

class LinkedOccurrence {
    button_text: string = '';
    item_id: string = '';
    item_date: string = '';
    linked_item_id: string = '';
    linked_item_path: string = '';
    linked_item_photo: string = '';
    linked_item_description: string = '';
    linked_item_external_link: string = '';
    linked_item_title: string = '';
    display_from: string = '';
    display_until: string = '';
    status: string = 'public';
    item: any = {};
    icon: string = 'calendar';

    constructor(linkedOccurrenceObject?: any) {
        // get each key
        for(let key in linkedOccurrenceObject) {
            if (this.hasOwnProperty(key)) {
                (<any>this)[key] = linkedOccurrenceObject[key];
            }
        }

        if(this.item) {
            this.getItemDetails();
        }
    }

    getItemDetails() {
        this.linked_item_title = this.item.title ? this.item.title : '';
        this.linked_item_path = this.item.path ? this.item.path : '';
        this.linked_item_photo = this.item.photos && this.item.photos.length > 0 && this.item.photos[0].path ? this.item.photos[0].path : '';
    }

    /**
     * @desc checks if the linked occurrence can be displayed
     * @param {moment.Moment}
     * @return {boolean}
     */
    canDisplayTypeNow(serverTime: moment.Moment) : boolean {
        let displayFrom = this.display_from ? moment(this.display_from) : false;
        let displayUntil = this.display_until ? moment(this.display_until) : false;

        let canDisplayFrom = !displayFrom || !displayFrom.isValid() || displayFrom.isSameOrBefore(serverTime);
        let canDisplayUntil = !displayUntil || !displayUntil.isValid() || displayUntil.isAfter(serverTime);

        return canDisplayFrom && canDisplayUntil;
    }
}

export default LinkedOccurrence;